import { Component } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {ButtonIconComponent} from "../button-icon/button-icon.component";

@Component({
  selector: 'app-modal-footer',
  standalone: true,
  imports: [
    TranslateModule,
    ButtonIconComponent,
  ],
  templateUrl: './modal-footer.component.html',
  styleUrl: './modal-footer.component.scss'
})
export class ModalFooterComponent {

}
